import { ZMultiplacerModuleKey } from "./schemas/foundationSchema";
import { DesignLeftSideBarTabs, RoomSideBarTabs } from "./designEnums";
export var DesignDiscipline;
(function (DesignDiscipline) {
    DesignDiscipline["ARK"] = "ARK";
    DesignDiscipline["RIE"] = "RIE";
    DesignDiscipline["RIV"] = "RIV";
    DesignDiscipline["RIS"] = "RIS";
})(DesignDiscipline || (DesignDiscipline = {}));
export var DesignRole;
(function (DesignRole) {
    DesignRole["BIM_SAMORDNER"] = "BIM-samordner";
    DesignRole["PROSJEKTERANDE"] = "Prosjekterende";
    DesignRole["DISCIPLINELEDER"] = "Disiplinleder";
    DesignRole["PROSJEKTLEDER"] = "Prosjektleder";
})(DesignRole || (DesignRole = {}));
export var DesignPhase;
(function (DesignPhase) {
    DesignPhase["DETALJPROSJEKTERING"] = "Detaljprosjektering";
    DesignPhase["TIDIG_FASE"] = "Tidlig fase";
})(DesignPhase || (DesignPhase = {}));
export const DISCIPLINE_DEFINITIONS = {
    [DesignDiscipline.RIE]: {
        key: DesignDiscipline.RIE,
        label: "RIE",
        color: "#a61e4d",
        backgroundColor: "#ffe3f3",
    },
    [DesignDiscipline.RIV]: {
        key: DesignDiscipline.RIV,
        label: "RIV",
        color: "#1864ab",
        backgroundColor: "#d0ebff",
    },
    [DesignDiscipline.RIS]: {
        key: DesignDiscipline.RIS,
        label: "RIS",
        color: "#c92a2a",
        backgroundColor: "#ffe3e3",
    },
    [DesignDiscipline.ARK]: {
        key: DesignDiscipline.ARK,
        label: "ARK",
        color: "#2f9e44",
        backgroundColor: "#d3f9d8",
    },
};
export const ROLE_DEFINITIONS = {
    [DesignRole.BIM_SAMORDNER]: {
        key: DesignRole.BIM_SAMORDNER,
        label: DesignRole.BIM_SAMORDNER,
    },
    [DesignRole.PROSJEKTERANDE]: {
        key: DesignRole.PROSJEKTERANDE,
        label: DesignRole.PROSJEKTERANDE,
    },
    [DesignRole.DISCIPLINELEDER]: {
        key: DesignRole.DISCIPLINELEDER,
        label: DesignRole.DISCIPLINELEDER,
    },
    [DesignRole.PROSJEKTLEDER]: {
        key: DesignRole.PROSJEKTLEDER,
        label: DesignRole.PROSJEKTLEDER,
    },
};
export const PHASE_DEFINITIONS = {
    [DesignPhase.DETALJPROSJEKTERING]: {
        key: DesignPhase.DETALJPROSJEKTERING,
        label: "Detaljprosjektering",
    },
    [DesignPhase.TIDIG_FASE]: {
        key: DesignPhase.TIDIG_FASE,
        label: "Tidlig fase",
    },
};
export const MULTIPLACER_MODULES = [
    {
        key: ZMultiplacerModuleKey.enum.CEILING,
        title: "Himling",
        description: "AI-drevet himlingsprosjektering som automatisk plasserer ventiler, armaturer og tekniske enheter basert på romgeometri og faglige krav. Sørger for rask, konsistent og optimal design - hver eneste gang.",
        disciplines: [DesignDiscipline.RIE, DesignDiscipline.RIV, DesignDiscipline.RIS],
        roles: [DesignRole.PROSJEKTERANDE],
        phases: [DesignPhase.DETALJPROSJEKTERING],
    },
    {
        key: ZMultiplacerModuleKey.enum.RFP,
        title: "RFP-validering",
        description: "Automatisk validering av tekniske fag mot romprogram (RFP). Sammenligner instansrom i modellen med tilhørende standardrom og avdekker avvik i areal, funksjon og krav - før de blir et prosjektproblem.",
        disciplines: [DesignDiscipline.RIE, DesignDiscipline.RIV, DesignDiscipline.RIS],
        roles: [DesignRole.PROSJEKTERANDE, DesignRole.DISCIPLINELEDER, DesignRole.PROSJEKTLEDER],
        phases: [DesignPhase.DETALJPROSJEKTERING],
    },
    {
        key: ZMultiplacerModuleKey.enum.EXPLORE,
        title: "Utforsker",
        description: "Generell utforsking av prosjektdata. Bruk modulen til å navigere, søke og inspisere innhold uten å gjøre endringer.",
        disciplines: [
            DesignDiscipline.RIE,
            DesignDiscipline.RIV,
            DesignDiscipline.RIS,
            DesignDiscipline.ARK,
        ],
        roles: [
            DesignRole.PROSJEKTERANDE,
            DesignRole.DISCIPLINELEDER,
            DesignRole.PROSJEKTLEDER,
            DesignRole.BIM_SAMORDNER,
        ],
        phases: [DesignPhase.DETALJPROSJEKTERING, DesignPhase.TIDIG_FASE],
    },
    {
        key: ZMultiplacerModuleKey.enum.ROOM_NUMBERING,
        title: "Romnummerering",
        description: "Beregner romnummer automatisk basert på definerte vilkår og regler. Gir konsistent romnummerering på tvers av prosjektet og gjør det enklere å kvalitetssikre navngivning og struktur.",
        disciplines: [DesignDiscipline.ARK],
        roles: [DesignRole.PROSJEKTERANDE, DesignRole.BIM_SAMORDNER],
        phases: [DesignPhase.DETALJPROSJEKTERING],
        defaultRoomColoringId: "ROOM_NUMBERING",
    },
];
export const isModuleVisibleForProject = (module, projectNo, isInDev) => {
    if (module.devOnly && !isInDev) {
        return false;
    }
    if (module.visibleForProjectNos == null) {
        return true;
    }
    if (projectNo == null) {
        return false;
    }
    return module.visibleForProjectNos.includes(projectNo);
};
export const getVisibleModulesForProject = (projectNo, isInDev) => {
    return MULTIPLACER_MODULES.filter((module) => isModuleVisibleForProject(module, projectNo, isInDev));
};
export const MULTIPLACER_MODULES_BY_KEY = MULTIPLACER_MODULES.reduce((acc, m) => {
    acc[m.key] = m;
    return acc;
}, {});
export const LEFT_SIDEBAR_TABS_BY_MODULE = {
    CEILING: [
        DesignLeftSideBarTabs.CEILING_VALIDATIONS,
        DesignLeftSideBarTabs.CEILING_HELP,
        DesignLeftSideBarTabs.CEILING_SETTINGS,
        DesignLeftSideBarTabs.DEVICE_HISTORY,
        DesignLeftSideBarTabs.MCBIMITEM_INFO,
        DesignLeftSideBarTabs.ROUTING_GRAPHS,
    ],
    RFP: [DesignLeftSideBarTabs.MCBIMITEM_INFO, DesignLeftSideBarTabs.ROUTING_GRAPHS],
    EXPLORE: [DesignLeftSideBarTabs.MCBIMITEM_INFO, DesignLeftSideBarTabs.ROUTING_GRAPHS],
    ROOM_NUMBERING: [DesignLeftSideBarTabs.MCBIMITEM_INFO, DesignLeftSideBarTabs.ROUTING_GRAPHS],
};
export const LEFT_SIDEBAR_DEFAULT_TAB_BY_MODULE = {
    CEILING: undefined,
    RFP: undefined,
    EXPLORE: undefined,
    ROOM_NUMBERING: undefined,
};
export const ROOM_SIDEBAR_TABS_BY_MODULE = {
    CEILING: [
        RoomSideBarTabs.CEILING_MULTIPLACER_PRODUCTS,
        RoomSideBarTabs.CEILING_AI_PREDICTIONS,
        RoomSideBarTabs.ROOM_SECTION_VIEWS,
        RoomSideBarTabs.CEILING_STANDARD_ROOM,
        RoomSideBarTabs.CEILING_VALIDATIONS,
        RoomSideBarTabs.CEILING_COMMENTS,
        RoomSideBarTabs.ROOM_INFO,
        RoomSideBarTabs.ROOM_SPECIFIED_ARTICLES,
    ],
    RFP: [
        RoomSideBarTabs.ROOM_SECTION_VIEWS,
        RoomSideBarTabs.CEILING_STANDARD_ROOM,
        RoomSideBarTabs.RFP_STANDARD_ROOM_DIFF,
        RoomSideBarTabs.ROOM_INFO,
        RoomSideBarTabs.ROOM_SPECIFIED_ARTICLES,
    ],
    EXPLORE: [
        RoomSideBarTabs.ROOM_SECTION_VIEWS,
        RoomSideBarTabs.ROOM_INFO,
        RoomSideBarTabs.ROOM_SPECIFIED_ARTICLES,
    ],
    ROOM_NUMBERING: [RoomSideBarTabs.ROOM_NUMBERING_DETAILS],
};
export const ROOM_SIDEBAR_DEFAULT_TAB_BY_MODULE = {
    CEILING: RoomSideBarTabs.CEILING_MULTIPLACER_PRODUCTS,
    RFP: RoomSideBarTabs.RFP_STANDARD_ROOM_DIFF,
    EXPLORE: RoomSideBarTabs.ROOM_SPECIFIED_ARTICLES,
    ROOM_NUMBERING: RoomSideBarTabs.ROOM_NUMBERING_DETAILS,
};
